/**
 * Presentational 0–max semicircular score gauge (reusable; BAIA gut-health result).
 * Themeable via CSS vars; no quiz coupling. Shows the numeric value only — the tier
 * label/copy is rendered separately (e.g. by ResultScreen).
 */
export function ScoreGauge({ value, max = 100 }: { value: number; max?: number }) {
  const safeMax = max <= 0 ? 1 : max;
  const clamped = Math.max(0, Math.min(safeMax, Math.round(value)));
  const pct = clamped / safeMax;
  const ARC = Math.PI * 90; // length of the r=90 semicircle path below

  return (
    <div className="qk-gauge" style={{ width: "100%", maxWidth: 240, margin: "0 auto 1rem", textAlign: "center" }}>
      <svg viewBox="0 0 200 110" width="100%" role="img" aria-label={`${clamped} de ${safeMax}`}>
        <path
          d="M10 100 A 90 90 0 0 1 190 100"
          fill="none"
          stroke="var(--color-border)"
          strokeWidth="14"
          strokeLinecap="round"
        />
        <path
          d="M10 100 A 90 90 0 0 1 190 100"
          fill="none"
          stroke="var(--color-accent)"
          strokeWidth="14"
          strokeLinecap="round"
          strokeDasharray={`${pct * ARC} ${ARC}`}
        />
      </svg>
      <div style={{ fontFamily: "var(--font-title)", fontSize: "2.5rem", lineHeight: 1, color: "var(--color-ink)", marginTop: "-1.75rem" }}>
        {clamped}
      </div>
      <div style={{ color: "var(--color-muted)", fontSize: "0.875rem" }}>/ {safeMax}</div>
    </div>
  );
}
